import React, { useEffect, useState } from "react";
import { Table, Select, Input } from "antd";
import styles from "./Yardsales.module.css";
import { useNavigate } from "react-router-dom";
import { TextComponent, SubmitButton, Modal } from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { YardsaleMiddleware } from "../../../Store/Middlewares/YardsalesMiddleware";
import moment from "moment";
import Pagination from "../../../components/Pagination/Pagination";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { showAlert } from "../../../Store/Actions/GeneralActions";


const Yardsales = () => {

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const DATA = useSelector(state => state.YardsaleReducer?.yardSales);
  const DATA_PAGINATION = useSelector(state => state.YardsaleReducer?.yardSalesPagination);

  const [currentPage, setCurrentPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(12);

  const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
  const [selectedYardsale, setSelectedYardsale] = useState(null);
  const [reason, setReason] = useState("");

  useEffect(() => {
    getData()
  }, []);

  const getData = (arg) => {
    const data = {
      limit: pageLimit,
      page: 1,
    };
    dispatch(YardsaleMiddleware.onGetYardsales(arg || data))
      .then((res) => { })
      .catch((err) => { console.log("Error fetching data:", err) });
  }

  const onClickDeactivateSale = () => {
    if (!reason) {
      dispatch(showAlert({ message: "Please enter a reason for deactivation", type: "Warning" }))
      return;
    }
    setOpenDeactivateModal(false);
    dispatch(YardsaleMiddleware.onDeactivateYardsale({ id: selectedYardsale?.id, reason: reason }))
      .then((res) => { })
      .catch((err) => { console.log("Error clicking deactivate", err) })
      .finally(() => {
        setReason("");
        setSelectedYardsale(null);
      });
  }

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "Title",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black" }}
          />
        );
      },
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "Category",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black" }}
          />
        );
      },
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "Start Date",
      render: (text, record) => {
        return (
          <TextComponent
            text={moment(text).format("MMM, DD, YYYY")}
            style={{ color: "black" }}
          />
        );
      },
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "End Date",
      render: (text, record) => {
        return (
          <TextComponent
            text={moment(text).format("MMM, DD, YYYY")}
            style={{ color: "black" }}
          />
        );
      },
    },
    
    {
      title: "Interested Buyers",
      dataIndex: "interestedCount",
      key: "Interested Buyers",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black" }}
          />
        );
      },
    },

 {
      title: "",
      key: "action",
      render: (_, record) => (
          <button className={styles.TableButton} onClick={() => {navigate('/YardsaleDetails', { state: { userId: record?.id } })}}>
            Details
          </button>
      ),
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        (record?.status == 'ongoing' || record?.status == 'upcoming') ?
          <button className={styles.TableButtonx} onClick={() => {
            setSelectedYardsale(record);
            setOpenDeactivateModal(true);
          }}>
            Deactivate
          </button>
          :
          <TextComponent
            text={record?.status.charAt(0).toUpperCase() + record?.status.slice(1)}
            style={{ color: record?.status == 'completed' ? '#00A36C' : 'red' }}
          />
      ),
    },
  ];

  return (
    <div className={styles.mainCont}>

      <div className={styles.HeadingDiv}>
        <TextComponent
          className={styles.Heading}
          text={"Yardsales"}
        />
      </div>


      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={DATA}
          pagination={false}
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px'
          }}
        />

        {

          (DATA_PAGINATION?.totalPages > 1) &&
          <Pagination
            currentPage={currentPage}
            totalPages={DATA_PAGINATION?.totalPages}
            nextButton={(e) => {
              getData({
                limit: pageLimit,
                page: currentPage + 1,
              });
              setCurrentPage(currentPage + 1);
            }}
            previousButton={(e) => {
              getData({
                limit: pageLimit,
                page: currentPage - 1,
              });
              setCurrentPage(currentPage - 1);
            }}
          />
        }


      </div>

      <Modal
        footer={false}
        closeIcon={<AiOutlineCloseCircle color="black" size={20} />}
        open={openDeactivateModal}
        onCancel={() => {
          setOpenDeactivateModal(false)
        }}
      >
        <div className={styles.modal}>
          <TextComponent text={"Deactivate Yardsale"} className={'modalheading'} />


          <Input.TextArea
            className={'modalInput'}
            placeholder="Reason for deactivation"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={4}
          />


          <div className={'modalFooter'}>

            <SubmitButton
              title={"Cancel"}
              btnClass={'modalBtn'}
              primary
              onClick={() => setOpenDeactivateModal(false)}
            />


            <SubmitButton
              title={"Submit"}
              btnClass={'modalBtn'}
              secondaryBtn
              onClick={onClickDeactivateSale}
            />
          </div>

        </div>
      </Modal>

    </div>
  );
};

export default Yardsales;
